import { useSplitTests } from '@api/lendingAPI/lapiHooks';

export const useRepaymentReductionSplitTest = () => {
    const isInRepaymentReductionSplitTest = useSplitTests(
        'de_repayment_reduction_test_2025'
    );

    return {
        isInRepaymentReductionSplitTest
    };
};
